export function isError(value) {
    return value && value.error;
}